import React from 'react'

const Projects = () => (
  <div>
    <h3>Your Projects</h3>
  </div>
)

export default Projects



// WEBPACK FOOTER //
// ./src/components/Projects/Projects.js